import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ExternalLink } from '..';
import { SecondaryButton } from '../../components';

// import classNames from 'classnames';                                  /*strg + p to search files !!!!*/
// import { NamedLink } from '..';
import css from './ImpactRepSection.css';
import image2022 from '../../assets/aboutPage/ImpactReports/2022.webp';
import file2022de from '../../assets/aboutPage/ImpactReports/ImpactReport22-de.pdf';
import file2022en from '../../assets/aboutPage/ImpactReports/ImpactReport22-en.pdf';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class ImpactRepSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleClass: css.none,
      visibleLessButton: false,
      visibleMoreButton: true,
    };
  }

  render() {
    


 
    return (
        <>
        <div className={css.sectionWrapper}>
          <h1 className={css.sectionHeader}>
            <FormattedMessage id="about.impactReportHeadline" />
          </h1>
          <div>
            {cookies.get('language') === 'en' ? (
              <div className={css.contentContainer}>
                <div className={css.imageContainer}>
                  <ExternalLink href={file2022en}>
                    <div class={css.container}>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                    </div>
                  </ExternalLink>
                </div>
                <div className={css.textContainer}>
                  <div>
                    <FormattedMessage id="about.impactText" />
                  </div>
                  <br/>
                  <div>
                    <ExternalLink href={file2022en}>
                      <SecondaryButton><FormattedMessage id="about.impactButton" /></SecondaryButton>
                    </ExternalLink>
                  </div>
                </div>
              </div>  
              ) : (
              <div className={css.contentContainer}>
                <div className={css.imageContainer}>
                  
                  <ExternalLink href={file2022de}>
                    <div class={css.container}>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                      <img className={css.reportImage} src={image2022} alt="Clickable Image"/>
                    </div>
                  </ExternalLink>
                </div>
                <div className={css.textContainer}>
                  <div>
                    <FormattedMessage id="about.impactText" />
                  </div>
                  <br/>
                  <div>
                    <ExternalLink href={file2022de}>
                      <SecondaryButton><FormattedMessage id="about.impactButton" /></SecondaryButton>
                    </ExternalLink>
                  </div>
                </div>
              </div> 
                
            )}

            
          </div>
          
        </div>

        
        </>
    );
      
     
  }
}



export default ImpactRepSection;